var _path, _circle, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 69,
    viewBox: "0 0 83 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8997 10.5182L3.53549 40.8824C1.58287 42.835 1.58287 46.0008 3.53549 47.9534L20.9782 65.3962C22.9308 67.3488 26.0967 67.3488 28.0493 65.3961L58.4135 35.032C59.3511 34.0943 59.8779 32.8225 59.8779 31.4964V14.0537C59.8779 11.2923 57.6394 9.05371 54.8779 9.05371H37.4352C36.1091 9.05371 34.8373 9.5805 33.8997 10.5182Z",
    fill: "#E72626"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.41119,
    cy: 2.41119,
    r: 2.41119,
    transform: "matrix(-1 0 0 1 51.0371 17.0747)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2142 19.6618C47.9706 19.5317 47.8786 19.2287 48.0088 18.9852C48.1389 18.7416 48.4418 18.6497 48.6854 18.7798L48.2142 19.6618ZM49.642 9.10443L49.1893 9.31671L48.7647 8.41132L49.2174 8.19903L49.642 9.10443ZM48.6854 18.7798C55.8729 22.6198 63.0021 22.2583 68.7969 19.9641C74.6118 17.6619 79.0436 13.4295 80.8262 9.59633C81.7185 7.67764 81.917 5.92944 81.3951 4.58273C80.8842 3.26437 79.6301 2.19987 77.3111 1.74036C74.979 1.27824 71.6221 1.44425 67.0483 2.57295C62.4816 3.69992 56.7357 5.77801 49.642 9.10443L49.2174 8.19903C56.3498 4.85449 62.1595 2.74942 66.8087 1.60208C71.4509 0.45649 74.9703 0.257066 77.5055 0.759435C80.054 1.26442 81.6582 2.49434 82.3275 4.22138C82.9858 5.92007 82.6862 7.96827 81.733 10.018C79.8246 14.1217 75.1753 18.5143 69.165 20.8939C63.1346 23.2814 55.6944 23.6583 48.2142 19.6618L48.6854 18.7798Z",
    fill: "url(#paint0_linear_8222_25772)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8222_25772",
    x1: 47.9642,
    y1: 18.5478,
    x2: 45.0396,
    y2: 14.4533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.7e621e390cc1d329bb1b8c2bb79a9700.svg";
export { ForwardRef as ReactComponent };